// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#Toolbar {\n    margin: 0.25em;\n    flex: 0 0 auto;\n}\n\n#Toolbar > .icon {\n    width: 2.5em;\n    height: 2.5em;\n    margin-right: 0.25em;\n    padding: 0.25em;\n    border: 1px solid transparent;\n}\n\n#Toolbar > .icon:hover,\n#Toolbar > .toolbar-item-active {\n    border: 1px solid #bbb;\n    background-color: #dcdcdc;\n}\n", ""]);
// Exports
module.exports = exports;
